export const forbiddenSchemes = [
  'WJK',
  'WEK',
  'WEJ',
  'WJH',
  'WJP',
  'WJN',
  '6ZN',
  '7HC',
  '7TL',
  '7TM',
  '7UC',
  '9ZW',
  'A4U',
  'A5C',
  'AAG',
  'AB9',
  'AD3',
  'AEA',
  'B4G',
  'B5V',
  'H8A',
  'T3M',
  'T3Z',
  'VHM',
  'VHQ',
];
